<app-modal-header>
  <div class="flex">
    <svg-icon class="hidden w-24 md:block" src="assets/images/logos/logo-eclass.svg"></svg-icon>
    <hr app-modal-divider />
    <h1 translate class="ml-2 flex items-center text-xl font-medium text-base-ea-700">
      {{ data.groupName }}
    </h1>
  </div>
</app-modal-header>
<div app-modal-content class="h-[75vh] w-[70vw] !p-0">
  <app-sidenav-group class="h-full w-full">
    <ng-template app-sidenav-outer>
      <div class="flex w-full flex-col px-5 py-8">
        <div class="flex">
          <app-form-field class="w-full md:w-52">
            <label app-label class="px-4" translate>zoom.data-gravacao</label>
            <app-input-datepicker [formControl]="dateControl" />
          </app-form-field>
        </div>
        <ng-container *ngIf="records$ | async as records; else loading">
          <ng-container *ngIf="records.length > 0; else emptyTemplate">
            <table
              class="w-full table-fixed border-separate border-spacing-y-3 rounded-xl border border-transparent text-sm"
            >
              <thead>
                <tr class="w-full text-sm text-gray-700">
                  <th class="w-20 px-4 text-start text-sm" translate>zoom.gravacao</th>
                  <th class="w-20 px-4 text-start text-sm" translate>zoom.senha</th>
                  <th class="w-20 px-4 text-end text-sm" translate>zoom.opcoes</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let record of records">
                  <tr class="h-14 w-full rounded-xl bg-base-zoom-100 pb-2 shadow-sm shadow-base-gray-300/40">
                    <td class="table-cell rounded-l-md border-l-4 border-base-zoom-500 px-3 py-3">
                      <div class="flex flex-col">
                        <h1 class="text-base font-normal leading-5 text-base-gray-700">{{ record.data }}</h1>
                        <p class="text-base font-light leading-5 text-base-gray-700">
                          {{ record.h_start }} {{ 'zoom.ate' | translate }} {{ record.h_end }}
                        </p>
                      </div>
                    </td>
                    <td class="table-cell items-start justify-start px-4 py-2">
                      <div class="flex flex-row gap-2 leading-5">
                        <ng-container *ngIf="record.senha; else noKey">
                          <a
                            (click)="copyKey(record.senha)"
                            class="flex h-6 cursor-pointer select-none items-center justify-center gap-2 rounded-full bg-base-status-warning-500 px-4 py-2 text-base font-medium text-white hover:brightness-100"
                            translate
                            app-tooltip
                            [tooltip]="'zoom.copiar' | translate"
                            >{{ record.senha }}</a
                          >
                        </ng-container>
                        <ng-template #noKey>
                          <span
                            class="flex h-6 select-none items-center justify-center gap-2 rounded-full bg-base-status-inactive px-4 py-2 text-base font-medium text-white hover:brightness-100"
                            translate
                            >zoom.sem-senha-gravacao</span
                          >
                        </ng-template>
                      </div>
                    </td>
                    <td class="items-center justify-start gap-2 rounded-r-lg px-4 py-3">
                      <div class="flex flex-row items-center justify-end gap-2 text-center">
                        <a
                          class="flex h-[32px] w-[32px] cursor-pointer flex-row items-center justify-center gap-2 rounded-lg border border-base-status-info-500 px-2 py-2 font-semibold text-base-status-info-500 shadow-sm shadow-gray-500/40 hover:brightness-110"
                          app-tooltip
                          [tooltip]="'zoom.link' | translate"
                          (click)="copyKey(record.url_video)"
                        >
                          <svg-icon class="flex h-5 w-5" src="assets/icons/icon-link-types.svg"></svg-icon>
                        </a>
                        <a
                          [href]="record.url_audio"
                          target="_blank"
                          class="flex h-[32px] w-[32px] cursor-pointer flex-row items-center justify-center gap-2 rounded-lg border border-base-status-info-500 px-2 py-2 font-semibold text-base-status-info-500 shadow-sm shadow-gray-500/40 hover:brightness-110"
                          app-tooltip
                          [tooltip]="'zoom.audio' | translate"
                        >
                          <svg-icon class="flex h-5 w-5" src="assets/icons/icon-audio-types.svg"></svg-icon>
                        </a>
                        <a
                          [href]="record.url_video"
                          target="_blank"
                          class="flex h-[32px] w-[32px] cursor-pointer flex-row items-center justify-center gap-2 rounded-lg border border-base-status-info-500 px-2 py-2 font-semibold text-base-status-info-500 shadow-sm shadow-gray-500/40 hover:brightness-110"
                          app-tooltip
                          [tooltip]="'zoom.video' | translate"
                        >
                          <svg-icon class="flex h-5 w-5" src="assets/icons/icon-video-session.svg"></svg-icon>
                        </a>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-container>
        </ng-container>
        <ng-template #loading>
          <div class="h-[200px] w-full animate-pulse">
            <app-jumbotron class="w-full"></app-jumbotron>
          </div>
        </ng-template>
        <ng-template #emptyTemplate>
          <app-jumbotron class="w-full py-8">
            {{ 'zoom.nenhuma-gravacao' | translate }}
          </app-jumbotron>
        </ng-template>
      </div>
    </ng-template>
  </app-sidenav-group>
</div>
